import Buttons from "../../../components/UI/Buttons";
import SectionLoader from "../../../components/UI/SectionLoader";
import { encryptString } from "../../../utils/commonUtils";

const Physical = (props) => {
    const { data,filter,isLoading} = props;
    const { physical } = data;
    const {company_id,clinic_id}=filter;
    const filterParams=encryptString({
        visit_category:'Employer Services - Physicals',
        company_id:company_id || '',
        clinic_id:clinic_id || '',
      });
    return (
        <div className="col-md-4 col-12 mb-2 pb-1">
            <div className="d-flex  align-items-top w-100 sh_newdashcard palemauve" >
                <div class="d-flex flex-column  w-100">
                    <h1 class="p1-strong mb-2">Physicals</h1>
                    <div class="d-flex justify-content-between">
                        <p class="p3-light text-dark mb-1">
                            <span class="mr-1">
                                <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect y="0.5" width="12" height="12" rx="6" fill="#7D4BC5"></rect>
                                </svg>
                            </span>
                            Completed</p>
                        <p class="p3-light text-dark mb-1">{physical?.completed || 0}</p>
                    </div>
                    <div class="d-flex justify-content-between">
                        <p class="p3-light text-dark mb-1">
                            <span class="mr-1">
                                <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect y="0.5" width="12" height="12" rx="6" fill="#F6447E"></rect>
                                </svg>
                            </span>
                            Pending</p>
                        <p class="p3-light text-dark mb-1">{physical?.pending || 0}</p>
                    </div>


                </div>
                <div class="w-100 d-flex justify-content-center">
                    <svg id="donutSvg" width="100" height="100" viewBox="0 0 136 136" stroke-width="6">
                        <circle class="bg" cx="68" cy="68" r="65" stroke="#f2f2f2" fill="none"></circle>

                        <circle id="seg4" class="sh_donutsegment" cx="68" cy="68" r="65" stroke="#7D4BC5" fill="none"></circle>
                        <circle id="seg5" class="sh_donutsegment" cx="68" cy="68" r="65" stroke="#F6447E" fill="none"></circle>

                        <g class="iconGroup" fill="transparent" transform="translate(50 50)">
                            <ellipse cx="20.3333" cy="10.1873" rx="5.52083" ry="5.52083" stroke="#5F6C85" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></ellipse>
                            <path d="M26.9974 35.5V21.2373" stroke="#5F6C85" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></path>
                            <path d="M20.3335 28.8334H16.1669C14.7862 28.8334 13.6669 29.9527 13.6669 31.3334V33.8334C13.6669 34.7539 14.4131 35.5 15.3335 35.5H30.3336C32.1746 35.5 33.667 34.0077 33.667 32.1667V29.4114C33.6761 25.5688 31.0533 22.2194 27.3206 21.307C22.7247 20.231 17.9424 20.231 13.3465 21.307C9.61368 22.2194 6.99084 25.5688 7.00002 29.4115L7.00021 33.8334" stroke="#5F6C85" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></path>
                            <path d="M20.3333 20.5V35.5" stroke="#5F6C85" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></path>
                        </g>
                    </svg>
                </div>
            </div>
 
        </div>
    );
}
export default Physical;